import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { accent, type AccentKey } from './theme';

export interface ServiceEndpoint {
  icon: string;
  title: string;
  items: string[];
}

interface SolutionServiceFlowProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  endpoints: ServiceEndpoint[];
  flow: string[];
  accentKey: AccentKey;
}

export default function SolutionServiceFlow({
  eyebrow,
  title,
  subtitle,
  endpoints,
  flow,
  accentKey,
}: SolutionServiceFlowProps) {
  const a = accent(accentKey);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={eyebrow} title={title} subtitle={subtitle} />

        {/* 三端结构 */}
        <Reveal className="mt-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {endpoints.map((endpoint) => (
              <div
                key={endpoint.title}
                className="p-6 rounded-lg bg-background-100 border border-background-200 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)]"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-md ${a.iconBox}`}>
                  <i className={`${endpoint.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-4 font-heading font-bold text-foreground-950 text-lg">{endpoint.title}</h3>
                <ul className="mt-4 space-y-2.5">
                  {endpoint.items.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm text-foreground-600 leading-relaxed">
                      <i className="ri-checkbox-circle-line text-accent-600 mt-0.5 shrink-0"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </Reveal>

        {/* 订单流主线 */}
        <Reveal className="mt-10" delay={100}>
          <div className="p-5 rounded-lg bg-background-100 border border-background-200">
            <div className="text-xs font-semibold text-foreground-400 mb-4 text-center">订单流主线</div>
            <div className="flex flex-wrap items-center justify-center gap-y-4">
              {flow.map((step, idx) => (
                <div key={step} className="flex items-center">
                  <span className={`px-4 py-2 rounded-full text-sm font-medium ${a.badgeLight} whitespace-nowrap`}>
                    {step}
                  </span>
                  {idx < flow.length - 1 && (
                    <i className="ri-arrow-right-line text-foreground-400 mx-2"></i>
                  )}
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}